/* components/ui/Vector.svelte generated by Svelte v3.32.1 */
import {
	SvelteComponent,
	add_flush_callback,
	add_render_callback,
	append,
	attr,
	bind,
	binding_callbacks,
	check_outros,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	safe_not_equal,
	select_option,
	select_value,
	set_data,
	space,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import Prop from "./Prop.svelte";
import NumberInput from "./dom/NumberInput.svelte";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[26] = list[i];
	return child_ctx;
}

// (48:4) {#if x != null}
function create_if_block_10(ctx) {
	let t0;
	let numberinput;
	let updating_value;
	let t1;
	let if_block1_anchor;
	let current;
	let if_block0 = /*components*/ ctx[1][0] && create_if_block_12(ctx);

	function numberinput_value_binding(value) {
		/*numberinput_value_binding*/ ctx[15].call(null, value);
	}

	let numberinput_props = {
		draggable: /*draggable*/ ctx[12],
		readonly: /*readonly*/ ctx[8],
		min: /*min*/ ctx[9],
		max: /*max*/ ctx[10],
		step: /*step*/ ctx[11]
	};

	if (/*x*/ ctx[2] !== void 0) {
		numberinput_props.value = /*x*/ ctx[2];
	}

	numberinput = new NumberInput({ props: numberinput_props });
	binding_callbacks.push(() => bind(numberinput, "value", numberinput_value_binding));
	numberinput.$on("input", /*input_handler*/ ctx[16]);
	let if_block1 = /*separator*/ ctx[0] && /*y*/ ctx[3] != null && create_if_block_11(ctx);

	return {
		c() {
			if (if_block0) if_block0.c();
			t0 = space();
			create_component(numberinput.$$.fragment);
			t1 = space();
			if (if_block1) if_block1.c();
			if_block1_anchor = empty();
		},
		m(target, anchor) {
			if (if_block0) if_block0.m(target, anchor);
			insert(target, t0, anchor);
			mount_component(numberinput, target, anchor);
			insert(target, t1, anchor);
			if (if_block1) if_block1.m(target, anchor);
			insert(target, if_block1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (/*components*/ ctx[1][0]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_12(ctx);
					if_block0.c();
					if_block0.m(t0.parentNode, t0);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			const numberinput_changes = {};
			if (dirty & /*draggable*/ 4096) numberinput_changes.draggable = /*draggable*/ ctx[12];
			if (dirty & /*readonly*/ 256) numberinput_changes.readonly = /*readonly*/ ctx[8];
			if (dirty & /*min*/ 512) numberinput_changes.min = /*min*/ ctx[9];
			if (dirty & /*max*/ 1024) numberinput_changes.max = /*max*/ ctx[10];
			if (dirty & /*step*/ 2048) numberinput_changes.step = /*step*/ ctx[11];

			if (!updating_value && dirty & /*x*/ 4) {
				updating_value = true;
				numberinput_changes.value = /*x*/ ctx[2];
				add_flush_callback(() => updating_value = false);
			}

			numberinput.$set(numberinput_changes);

			if (/*separator*/ ctx[0] && /*y*/ ctx[3] != null) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_11(ctx);
					if_block1.c();
					if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}
		},
		i(local) {
			if (current) return;
			transition_in(numberinput.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(numberinput.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t0);
			destroy_component(numberinput, detaching);
			if (detaching) detach(t1);
			if (if_block1) if_block1.d(detaching);
			if (detaching) detach(if_block1_anchor);
		}
	};
}

// (49:6) {#if components[0]}
function create_if_block_12(ctx) {
	let label_1;
	let t_value = /*components*/ ctx[1][0] + "";
	let t;

	return {
		c() {
			label_1 = element("label");
			t = text(t_value);
			attr(label_1, "class", "svelte-jq4jyp");
		},
		m(target, anchor) {
			insert(target, label_1, anchor);
			append(label_1, t);
		},
		p(ctx, dirty) {
			if (dirty & /*components*/ 2 && t_value !== (t_value = /*components*/ ctx[1][0] + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(label_1);
		}
	};
}

// (61:6) {#if separator && y != null}
function create_if_block_11(ctx) {
	let span;
	let t;

	return {
		c() {
			span = element("span");
			t = text(/*separator*/ ctx[0]);
			attr(span, "class", "svelte-jq4jyp");
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t);
		},
		p(ctx, dirty) {
			if (dirty & /*separator*/ 1) set_data(t, /*separator*/ ctx[0]);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (65:4) {#if y != null}
function create_if_block_7(ctx) {
	let t0;
	let numberinput;
	let updating_value;
	let t1;
	let if_block1_anchor;
	let current;
	let if_block0 = /*components*/ ctx[1][1] && create_if_block_9(ctx);

	function numberinput_value_binding_1(value) {
		/*numberinput_value_binding_1*/ ctx[17].call(null, value);
	}

	let numberinput_props = {
		draggable: /*draggable*/ ctx[12],
		readonly: /*readonly*/ ctx[8],
		min: /*min*/ ctx[9],
		max: /*max*/ ctx[10],
		step: /*step*/ ctx[11]
	};

	if (/*y*/ ctx[3] !== void 0) {
		numberinput_props.value = /*y*/ ctx[3];
	}

	numberinput = new NumberInput({ props: numberinput_props });
	binding_callbacks.push(() => bind(numberinput, "value", numberinput_value_binding_1));
	numberinput.$on("input", /*input_handler_1*/ ctx[18]);
	let if_block1 = /*separator*/ ctx[0] && /*z*/ ctx[4] != null && create_if_block_8(ctx);

	return {
		c() {
			if (if_block0) if_block0.c();
			t0 = space();
			create_component(numberinput.$$.fragment);
			t1 = space();
			if (if_block1) if_block1.c();
			if_block1_anchor = empty();
		},
		m(target, anchor) {
			if (if_block0) if_block0.m(target, anchor);
			insert(target, t0, anchor);
			mount_component(numberinput, target, anchor);
			insert(target, t1, anchor);
			if (if_block1) if_block1.m(target, anchor);
			insert(target, if_block1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (/*components*/ ctx[1][1]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_9(ctx);
					if_block0.c();
					if_block0.m(t0.parentNode, t0);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			const numberinput_changes = {};
			if (dirty & /*draggable*/ 4096) numberinput_changes.draggable = /*draggable*/ ctx[12];
			if (dirty & /*readonly*/ 256) numberinput_changes.readonly = /*readonly*/ ctx[8];
			if (dirty & /*min*/ 512) numberinput_changes.min = /*min*/ ctx[9];
			if (dirty & /*max*/ 1024) numberinput_changes.max = /*max*/ ctx[10];
			if (dirty & /*step*/ 2048) numberinput_changes.step = /*step*/ ctx[11];

			if (!updating_value && dirty & /*y*/ 8) {
				updating_value = true;
				numberinput_changes.value = /*y*/ ctx[3];
				add_flush_callback(() => updating_value = false);
			}

			numberinput.$set(numberinput_changes);

			if (/*separator*/ ctx[0] && /*z*/ ctx[4] != null) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_8(ctx);
					if_block1.c();
					if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}
		},
		i(local) {
			if (current) return;
			transition_in(numberinput.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(numberinput.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t0);
			destroy_component(numberinput, detaching);
			if (detaching) detach(t1);
			if (if_block1) if_block1.d(detaching);
			if (detaching) detach(if_block1_anchor);
		}
	};
}

// (66:6) {#if components[1]}
function create_if_block_9(ctx) {
	let label_1;
	let t_value = /*components*/ ctx[1][1] + "";
	let t;

	return {
		c() {
			label_1 = element("label");
			t = text(t_value);
			attr(label_1, "class", "svelte-jq4jyp");
		},
		m(target, anchor) {
			insert(target, label_1, anchor);
			append(label_1, t);
		},
		p(ctx, dirty) {
			if (dirty & /*components*/ 2 && t_value !== (t_value = /*components*/ ctx[1][1] + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(label_1);
		}
	};
}

// (78:6) {#if separator && z != null}
function create_if_block_8(ctx) {
	let span;
	let t;

	return {
		c() {
			span = element("span");
			t = text(/*separator*/ ctx[0]);
			attr(span, "class", "svelte-jq4jyp");
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t);
		},
		p(ctx, dirty) {
			if (dirty & /*separator*/ 1) set_data(t, /*separator*/ ctx[0]);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (82:4) {#if z != null}
function create_if_block_4(ctx) {
	let t0;
	let numberinput;
	let updating_value;
	let t1;
	let if_block1_anchor;
	let current;
	let if_block0 = /*components*/ ctx[1][2] && create_if_block_6(ctx);

	function numberinput_value_binding_2(value) {
		/*numberinput_value_binding_2*/ ctx[19].call(null, value);
	}

	let numberinput_props = {
		draggable: /*draggable*/ ctx[12],
		readonly: /*readonly*/ ctx[8],
		min: /*min*/ ctx[9],
		max: /*max*/ ctx[10],
		step: /*step*/ ctx[11]
	};

	if (/*z*/ ctx[4] !== void 0) {
		numberinput_props.value = /*z*/ ctx[4];
	}

	numberinput = new NumberInput({ props: numberinput_props });
	binding_callbacks.push(() => bind(numberinput, "value", numberinput_value_binding_2));
	numberinput.$on("input", /*input_handler_2*/ ctx[20]);
	let if_block1 = /*separator*/ ctx[0] && /*w*/ ctx[5] != null && create_if_block_5(ctx);

	return {
		c() {
			if (if_block0) if_block0.c();
			t0 = space();
			create_component(numberinput.$$.fragment);
			t1 = space();
			if (if_block1) if_block1.c();
			if_block1_anchor = empty();
		},
		m(target, anchor) {
			if (if_block0) if_block0.m(target, anchor);
			insert(target, t0, anchor);
			mount_component(numberinput, target, anchor);
			insert(target, t1, anchor);
			if (if_block1) if_block1.m(target, anchor);
			insert(target, if_block1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (/*components*/ ctx[1][2]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_6(ctx);
					if_block0.c();
					if_block0.m(t0.parentNode, t0);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			const numberinput_changes = {};
			if (dirty & /*draggable*/ 4096) numberinput_changes.draggable = /*draggable*/ ctx[12];
			if (dirty & /*readonly*/ 256) numberinput_changes.readonly = /*readonly*/ ctx[8];
			if (dirty & /*min*/ 512) numberinput_changes.min = /*min*/ ctx[9];
			if (dirty & /*max*/ 1024) numberinput_changes.max = /*max*/ ctx[10];
			if (dirty & /*step*/ 2048) numberinput_changes.step = /*step*/ ctx[11];

			if (!updating_value && dirty & /*z*/ 16) {
				updating_value = true;
				numberinput_changes.value = /*z*/ ctx[4];
				add_flush_callback(() => updating_value = false);
			}

			numberinput.$set(numberinput_changes);

			if (/*separator*/ ctx[0] && /*w*/ ctx[5] != null) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_5(ctx);
					if_block1.c();
					if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}
		},
		i(local) {
			if (current) return;
			transition_in(numberinput.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(numberinput.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t0);
			destroy_component(numberinput, detaching);
			if (detaching) detach(t1);
			if (if_block1) if_block1.d(detaching);
			if (detaching) detach(if_block1_anchor);
		}
	};
}

// (83:6) {#if components[2]}
function create_if_block_6(ctx) {
	let label_1;
	let t_value = /*components*/ ctx[1][2] + "";
	let t;

	return {
		c() {
			label_1 = element("label");
			t = text(t_value);
			attr(label_1, "class", "svelte-jq4jyp");
		},
		m(target, anchor) {
			insert(target, label_1, anchor);
			append(label_1, t);
		},
		p(ctx, dirty) {
			if (dirty & /*components*/ 2 && t_value !== (t_value = /*components*/ ctx[1][2] + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(label_1);
		}
	};
}

// (95:6) {#if separator && w != null}
function create_if_block_5(ctx) {
	let span;
	let t;

	return {
		c() {
			span = element("span");
			t = text(/*separator*/ ctx[0]);
			attr(span, "class", "svelte-jq4jyp");
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t);
		},
		p(ctx, dirty) {
			if (dirty & /*separator*/ 1) set_data(t, /*separator*/ ctx[0]);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (99:4) {#if w != null}
function create_if_block_2(ctx) {
	let t;
	let numberinput;
	let updating_value;
	let current;
	let if_block = /*components*/ ctx[1][3] && create_if_block_3(ctx);

	function numberinput_value_binding_3(value) {
		/*numberinput_value_binding_3*/ ctx[21].call(null, value);
	}

	let numberinput_props = {
		draggable: /*draggable*/ ctx[12],
		readonly: /*readonly*/ ctx[8],
		min: /*min*/ ctx[9],
		max: /*max*/ ctx[10],
		step: /*step*/ ctx[11]
	};

	if (/*w*/ ctx[5] !== void 0) {
		numberinput_props.value = /*w*/ ctx[5];
	}

	numberinput = new NumberInput({ props: numberinput_props });
	binding_callbacks.push(() => bind(numberinput, "value", numberinput_value_binding_3));
	numberinput.$on("input", /*input_handler_3*/ ctx[22]);

	return {
		c() {
			if (if_block) if_block.c();
			t = space();
			create_component(numberinput.$$.fragment);
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, t, anchor);
			mount_component(numberinput, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (/*components*/ ctx[1][3]) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_3(ctx);
					if_block.c();
					if_block.m(t.parentNode, t);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			const numberinput_changes = {};
			if (dirty & /*draggable*/ 4096) numberinput_changes.draggable = /*draggable*/ ctx[12];
			if (dirty & /*readonly*/ 256) numberinput_changes.readonly = /*readonly*/ ctx[8];
			if (dirty & /*min*/ 512) numberinput_changes.min = /*min*/ ctx[9];
			if (dirty & /*max*/ 1024) numberinput_changes.max = /*max*/ ctx[10];
			if (dirty & /*step*/ 2048) numberinput_changes.step = /*step*/ ctx[11];

			if (!updating_value && dirty & /*w*/ 32) {
				updating_value = true;
				numberinput_changes.value = /*w*/ ctx[5];
				add_flush_callback(() => updating_value = false);
			}

			numberinput.$set(numberinput_changes);
		},
		i(local) {
			if (current) return;
			transition_in(numberinput.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(numberinput.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(t);
			destroy_component(numberinput, detaching);
		}
	};
}

// (100:6) {#if components[3]}
function create_if_block_3(ctx) {
	let label_1;
	let t_value = /*components*/ ctx[1][3] + "";
	let t;

	return {
		c() {
			label_1 = element("label");
			t = text(t_value);
			attr(label_1, "class", "svelte-jq4jyp");
		},
		m(target, anchor) {
			insert(target, label_1, anchor);
			append(label_1, t);
		},
		p(ctx, dirty) {
			if (dirty & /*components*/ 2 && t_value !== (t_value = /*components*/ ctx[1][3] + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(label_1);
		}
	};
}

// (114:2) {#if units}
function create_if_block(ctx) {
	let div;

	function select_block_type(ctx, dirty) {
		if (/*unitTypes*/ ctx[13] && /*unitTypes*/ ctx[13].length) return create_if_block_1;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			div = element("div");
			if_block.c();
			attr(div, "class", "unit-container svelte-jq4jyp");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if_block.m(div, null);
		},
		p(ctx, dirty) {
			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(div, null);
				}
			}
		},
		d(detaching) {
			if (detaching) detach(div);
			if_block.d();
		}
	};
}

// (124:6) {:else}
function create_else_block(ctx) {
	let label_1;
	let t;

	return {
		c() {
			label_1 = element("label");
			t = text(/*units*/ ctx[6]);
			attr(label_1, "class", "svelte-jq4jyp");
		},
		m(target, anchor) {
			insert(target, label_1, anchor);
			append(label_1, t);
		},
		p(ctx, dirty) {
			if (dirty & /*units*/ 64) set_data(t, /*units*/ ctx[6]);
		},
		d(detaching) {
			if (detaching) detach(label_1);
		}
	};
}

// (116:6) {#if unitTypes && unitTypes.length}
function create_if_block_1(ctx) {
	let select;
	let mounted;
	let dispose;
	let each_value = /*unitTypes*/ ctx[13];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			select = element("select");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			attr(select, "class", "unit-select svelte-jq4jyp");
			if (/*units*/ ctx[6] === void 0) add_render_callback(() => /*select_change_handler*/ ctx[23].call(select));
		},
		m(target, anchor) {
			insert(target, select, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(select, null);
			}

			select_option(select, /*units*/ ctx[6]);

			if (!mounted) {
				dispose = listen(select, "change", /*select_change_handler*/ ctx[23]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*unitTypes*/ 8192) {
				each_value = /*unitTypes*/ ctx[13];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(select, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (dirty & /*units, unitTypes*/ 8256) {
				select_option(select, /*units*/ ctx[6]);
			}
		},
		d(detaching) {
			if (detaching) detach(select);
			destroy_each(each_blocks, detaching);
			mounted = false;
			dispose();
		}
	};
}

// (118:10) {#each unitTypes as item}
function create_each_block(ctx) {
	let option;

	let t0_value = (/*item*/ ctx[26] && /*item*/ ctx[26].name != null
	? /*item*/ ctx[26].name
	: /*item*/ ctx[26]) + "";

	let t0;
	let t1;
	let option_value_value;

	return {
		c() {
			option = element("option");
			t0 = text(t0_value);
			t1 = space();
			option.__value = option_value_value = /*item*/ ctx[26];
			option.value = option.__value;
		},
		m(target, anchor) {
			insert(target, option, anchor);
			append(option, t0);
			append(option, t1);
		},
		p(ctx, dirty) {
			if (dirty & /*unitTypes*/ 8192 && t0_value !== (t0_value = (/*item*/ ctx[26] && /*item*/ ctx[26].name != null
			? /*item*/ ctx[26].name
			: /*item*/ ctx[26]) + "")) set_data(t0, t0_value);

			if (dirty & /*unitTypes*/ 8192 && option_value_value !== (option_value_value = /*item*/ ctx[26])) {
				option.__value = option_value_value;
				option.value = option.__value;
			}
		},
		d(detaching) {
			if (detaching) detach(option);
		}
	};
}

// (46:0) <Prop {label}>
function create_default_slot(ctx) {
	let div;
	let t0;
	let t1;
	let t2;
	let t3;
	let if_block4_anchor;
	let current;
	let if_block0 = /*x*/ ctx[2] != null && create_if_block_10(ctx);
	let if_block1 = /*y*/ ctx[3] != null && create_if_block_7(ctx);
	let if_block2 = /*z*/ ctx[4] != null && create_if_block_4(ctx);
	let if_block3 = /*w*/ ctx[5] != null && create_if_block_2(ctx);
	let if_block4 = /*units*/ ctx[6] && create_if_block(ctx);

	return {
		c() {
			div = element("div");
			if (if_block0) if_block0.c();
			t0 = space();
			if (if_block1) if_block1.c();
			t1 = space();
			if (if_block2) if_block2.c();
			t2 = space();
			if (if_block3) if_block3.c();
			t3 = space();
			if (if_block4) if_block4.c();
			if_block4_anchor = empty();
			attr(div, "class", "value-container svelte-jq4jyp");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if (if_block0) if_block0.m(div, null);
			append(div, t0);
			if (if_block1) if_block1.m(div, null);
			append(div, t1);
			if (if_block2) if_block2.m(div, null);
			append(div, t2);
			if (if_block3) if_block3.m(div, null);
			insert(target, t3, anchor);
			if (if_block4) if_block4.m(target, anchor);
			insert(target, if_block4_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (/*x*/ ctx[2] != null) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty & /*x*/ 4) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_10(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(div, t0);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (/*y*/ ctx[3] != null) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty & /*y*/ 8) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_7(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div, t1);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (/*z*/ ctx[4] != null) {
				if (if_block2) {
					if_block2.p(ctx, dirty);

					if (dirty & /*z*/ 16) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block_4(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(div, t2);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}

			if (/*w*/ ctx[5] != null) {
				if (if_block3) {
					if_block3.p(ctx, dirty);

					if (dirty & /*w*/ 32) {
						transition_in(if_block3, 1);
					}
				} else {
					if_block3 = create_if_block_2(ctx);
					if_block3.c();
					transition_in(if_block3, 1);
					if_block3.m(div, null);
				}
			} else if (if_block3) {
				group_outros();

				transition_out(if_block3, 1, 1, () => {
					if_block3 = null;
				});

				check_outros();
			}

			if (/*units*/ ctx[6]) {
				if (if_block4) {
					if_block4.p(ctx, dirty);
				} else {
					if_block4 = create_if_block(ctx);
					if_block4.c();
					if_block4.m(if_block4_anchor.parentNode, if_block4_anchor);
				}
			} else if (if_block4) {
				if_block4.d(1);
				if_block4 = null;
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(if_block1);
			transition_in(if_block2);
			transition_in(if_block3);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(if_block1);
			transition_out(if_block2);
			transition_out(if_block3);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (if_block2) if_block2.d();
			if (if_block3) if_block3.d();
			if (detaching) detach(t3);
			if (if_block4) if_block4.d(detaching);
			if (detaching) detach(if_block4_anchor);
		}
	};
}

function create_fragment(ctx) {
	let prop;
	let current;

	prop = new Prop({
			props: {
				label: /*label*/ ctx[7],
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(prop.$$.fragment);
		},
		m(target, anchor) {
			mount_component(prop, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const prop_changes = {};
			if (dirty & /*label*/ 128) prop_changes.label = /*label*/ ctx[7];

			if (dirty & /*$$scope, units, unitTypes, draggable, readonly, min, max, step, w, components, separator, z, y, x*/ 536887167) {
				prop_changes.$$scope = { dirty, ctx };
			}

			prop.$set(prop_changes);
		},
		i(local) {
			if (current) return;
			transition_in(prop.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(prop.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(prop, detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { label = "" } = $$props;

	const presets = {
		array: { separator: "", components: [] },
		vector: {
			separator: ",",
			components: ["X", "Y", "Z", "W"]
		},
		color: {
			separator: ",",
			components: ["R", "G", "B", "A"]
		},
		size: {
			separator: "×",
			components: ["W", "H", "D", "T"]
		}
	};

	let { separator = presets.vector.separator } = $$props;
	let { components = presets.vector.components } = $$props;
	let { type = "vector" } = $$props;
	let { readonly = false } = $$props;
	let { x = undefined } = $$props;
	let { y = undefined } = $$props;
	let { z = undefined } = $$props;
	let { w = undefined } = $$props;
	let { min = undefined } = $$props;
	let { max = undefined } = $$props;
	let { step = undefined } = $$props;
	let { draggable = true } = $$props;
	let { units = undefined } = $$props;
	let { unitTypes = [] } = $$props;
	let list;

	function numberinput_value_binding(value) {
		x = value;
		$$invalidate(2, x);
	}

	const input_handler = ev => $$invalidate(2, x = +parseFloat(ev.currentTarget.value));

	function numberinput_value_binding_1(value) {
		y = value;
		$$invalidate(3, y);
	}

	const input_handler_1 = ev => $$invalidate(3, y = +parseFloat(ev.currentTarget.value));

	function numberinput_value_binding_2(value) {
		z = value;
		$$invalidate(4, z);
	}

	const input_handler_2 = ev => $$invalidate(4, z = +parseFloat(ev.currentTarget.value));

	function numberinput_value_binding_3(value) {
		w = value;
		$$invalidate(5, w);
	}

	const input_handler_3 = ev => $$invalidate(5, w = +parseFloat(ev.currentTarget.value));

	function select_change_handler() {
		units = select_value(this);
		$$invalidate(6, units);
		$$invalidate(13, unitTypes);
	}

	$$self.$$set = $$props => {
		if ("label" in $$props) $$invalidate(7, label = $$props.label);
		if ("separator" in $$props) $$invalidate(0, separator = $$props.separator);
		if ("components" in $$props) $$invalidate(1, components = $$props.components);
		if ("type" in $$props) $$invalidate(14, type = $$props.type);
		if ("readonly" in $$props) $$invalidate(8, readonly = $$props.readonly);
		if ("x" in $$props) $$invalidate(2, x = $$props.x);
		if ("y" in $$props) $$invalidate(3, y = $$props.y);
		if ("z" in $$props) $$invalidate(4, z = $$props.z);
		if ("w" in $$props) $$invalidate(5, w = $$props.w);
		if ("min" in $$props) $$invalidate(9, min = $$props.min);
		if ("max" in $$props) $$invalidate(10, max = $$props.max);
		if ("step" in $$props) $$invalidate(11, step = $$props.step);
		if ("draggable" in $$props) $$invalidate(12, draggable = $$props.draggable);
		if ("units" in $$props) $$invalidate(6, units = $$props.units);
		if ("unitTypes" in $$props) $$invalidate(13, unitTypes = $$props.unitTypes);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*type*/ 16384) {
			$: {
				if (type != null && typeof type === "string" && !(type in presets)) {
					throw new Error(`Unknown type preset ${type}`);
				}

				if (type && typeof type === "string") {
					const p = presets[type];
					$$invalidate(0, separator = p.separator);
					$$invalidate(1, components = p.components);
				} else if (type) {
					$$invalidate(0, separator = type.separator || "");
					$$invalidate(1, components = type.components || []);
				}
			}
		}
	};

	return [
		separator,
		components,
		x,
		y,
		z,
		w,
		units,
		label,
		readonly,
		min,
		max,
		step,
		draggable,
		unitTypes,
		type,
		numberinput_value_binding,
		input_handler,
		numberinput_value_binding_1,
		input_handler_1,
		numberinput_value_binding_2,
		input_handler_2,
		numberinput_value_binding_3,
		input_handler_3,
		select_change_handler
	];
}

class Vector extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			label: 7,
			separator: 0,
			components: 1,
			type: 14,
			readonly: 8,
			x: 2,
			y: 3,
			z: 4,
			w: 5,
			min: 9,
			max: 10,
			step: 11,
			draggable: 12,
			units: 6,
			unitTypes: 13
		});
	}
}

export default Vector;